<template>
  <div>
    <el-dialog
      :center="true"
      :visible.sync="dialogVisible"
      :show-close="false"
      :before-close="handleDialogClose"
      :close-on-click-modal="false"
      width="1024px">

      <div class="container-body">

        <div class="box-head">
          <div class="label-title">
            <!-- CSV取り込み -->
            <label slot="title">{{ $t("label.system.tenant.detail.addressBookCSVImport") }}</label>
          </div>
          <div class="btn-cancel">
            <!-- キャンセル -->
            <sp-smart-button @click="backCsvGet" slot="cancel">{{ $t("label.system.tenant.detail.cancel") }}</sp-smart-button>
          </div>
          <div class="btn-parimary">
            <!-- 確定 -->
            <narrow-down @click="searchDistribution" slot="create">{{ $t("label.system.tenant.detail.confirm") }}</narrow-down>
          </div>
        </div>

        <div class="hr-style"></div>

        <!-- 対象 -->
        <div class="flex-align-items-center m-bottom-head">
          <div class="input-margin-top line-height-40">
            {{ $t("label.common.object") }}
          </div>
          <div class="main-1">
            <div class="input-margin-top size-14">
              {{ this.title }}
            </div>

            <div class="box-1 size-14">
              {{ this.packtitle }}
            </div>
          </div>
        </div>

        <!--  CSVファイル -->
        <el-row>
          <el-form
            label-width="130px"
            label-position="left"
            ref="ruleForm"
            :rules="rules"
            :model="query"
            >
            <el-form-item
              class="input-margin-top item-height"
              :label="$t('label.system.tenant.detail.userCsvImport')"
              prop="fileName"
            >
              <el-input
                :readonly="true"
                v-model="query.fileName"
                class="input-width"
              >
              </el-input>
              <selectBtn class="selectBtns" @click="uploadfile">
                {{$t("label.system.tenant.detail.select")}}
              </selectBtn>
              <input
                ref="csvUpload"
                type="file"
                style="display: none"
                accept=".csv,.CSV"
                @change="getCsvfile"
              />
              <narrow-down @click="csvUploadData"  class="csvBtn">
                {{ $t("label.system.tenant.detail.qurdra") }}
              </narrow-down>
            </el-form-item>
          </el-form>
        </el-row>

        <!-- インポートが成功し、失敗数が表示されます  -->
        <div class="m-top" style="display: flex;">
          <div class="label-with float-left">
            <span class="color">
              {{ $t("label.system.tenant.search.result") }}
            </span>
          </div>
          <!-- <el-input
            id="textarea_result"
            :readonly="true"
            type="textarea"
            v-model="result.failureDetails.message"
            :autosize="{ minRows: 16, maxRows: 32 }"
            class="in-file-url-two float-left textarea-1"
          >
          </el-input> -->
          <div class="msg_box_style">
          <span v-if="result.failureDetails.message">{{ result.failureDetails.message }}</span>
            {{ resultstr }}
          </div>

        </div>
      </div>

      <loading-dialog :FileShowLoading="showLoading" />

    </el-dialog>
  </div>
</template>

<script>
import SystemManageApi from "@/api/SystemManageApi";
import selectBtn from "@/components/common/generalButton/Select";
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import errorCodeMsg from "@/utils/error-code-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import SpSmartButton from "@/components/common/sp-smart-button"
export default({
    name: "PackDistributionCsvGetPopup",
    components: {
      LoadingDialog: LoadingDialog,
      narrowDown,
      SpSmartButton,
      selectBtn,
    },
    data() {
      return {
        query: {
          file: null,
          fileName: null
        },
        result: {
        id: null,
        name: null,
        exId: null,
        successCount: null,
        failureCount: null,
        failureDetails: [
          {
            lineNo: null,
            message: '',
          },
        ],
        },
        centerDialogVisibleIsShow: false,
        dialogVisible: false,
        showLoading: false,
        titleName: "",
        packName: "",
        tenantId: "",
        ownerId: "",
        resultstr: "",
        successAccountId: [],
        title:'',
        packtitle:'',
        rules: {
          fileName: [
            {
              required: true,
              message: this.$t("message.common.validation.required", {
                field: "CSVファイル",
              }),
            },
          ],
        }
    }},
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      tenantTitle: {
        type: String,
        default: ""
      },
      tenantPackName: {
        type: String,
        default: ""
      },
    },
    watch: {
      visible: function(value) {
        this.resultstr = "";
        this.dialogVisible = value;
        this.title = JSON.parse(JSON.stringify(this.tenantTitle))
        this.packtitle = JSON.parse(JSON.stringify(this.tenantPackName))
        this.failureDetails = [
          {
            lineNo: null,
            message: '',
          }
        ]
        this.query.fileName = null;
        this.query.file = null;
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      },
      tenantTitle: function(value) {
        this.titleName = value;
      },
      tenantPackName: function(value) {
        this.packName = value;
      },
    },
    methods: {
      //ファイルファイルを取得
      getCsvfile() {
        let csvFile = this.$refs.csvUpload.files[0];
        var csvCheck = /\.(csv|CSV)$/;
        if (!csvCheck.test(csvFile.name)) {
          this.query.file = null;
        } else {

          this.query.file = csvFile;
          this.query.fileName = csvFile.name;
        }
        const isLt2M = csvFile.size / 1024 / 1024 < 15;
        if (!isLt2M) {
            this.query.fileName = null;
            this.$messageIotError(this.$t('message.common.error.ERR_FILE_SIZE_OVER_MSG',{size:'15M'}));
            return this.query.file = null
        }
        if (csvFile.size == 0) {
            this.query.fileName = null;
            this.$messageIotError(this.$t('message.common.error.ERR_FILE_EMPTY_MSG'));
            return this.query.file = null
        }
      },
      handleDialogClose(){
        this.query.fileName = null
        this.query.file = null;
        this.$refs["ruleForm"].clearValidate();
      },

      //アップロード入力ボックスを開きます
      uploadfile() {
        this.resultstr = ""
        this.$refs.csvUpload.value = null
        // document.getElementById('textarea_result').value = ""
        this.$refs.csvUpload.click();
      },
      backCsvGet(){
        this.resultstr = ""
        // document.getElementById('textarea_result').value = "";
        this.query.fileName = null;
        this.query.file = null;
        this.dialogVisible = false;
        this.successAccountId = []
        this.failureDetails = [
          {
            lineNo: null,
            message: '',
          }
        ]
        this.$emit('update:visible', false);
      },
      csvUploadData(){
        if(this.query.file == null){
          this.$messageIotError(this.$t('message.common.validation.required', {
            field: this.$t('label.system.owner.salesMachine.file')
          }))
        }else{
          this.FileShowLoading = true;
          SystemManageApi.SystemAccountReadCsv({
            tenantId: this.tenantId,
            ownerId: this.ownerId,
            csvFile: this.query.file,
          }).catch((error) => {
          errorCodeMsg(error, this);
          this.FileShowLoading = false;
          }).then(({data}) => {
            this.resultstr = ''
            // document.getElementById('textarea_result').value = ''
            this.FileShowLoading = false;
            if(data.body.successAccountId){
              this.successAccountId = data.body.successAccountId;
            }
            if(!statusErrorCodeMsg(data.statusCode, this, null, data)) {
              return this.query.file = null
            }
            if (data.body.failureCount > 0) {
                this.resultstr = this.$t('message.common.csvImport.ERR_FAILURE_MSG');
            } else {
                this.resultstr = this.$t('message.common.csvImport.INFO_SUCCESS_PACK_IMPORT_MSG',{amount:data.body.successCount});
            }
            for (let i = 0; i < data.body.failureDetails.length; i++) {
              let failureDetail = data.body.failureDetails[i]
              this.resultstr = this.resultstr + "\r\n" + this.$t('message.common.csvImport.ERR_' + failureDetail.message + '_MSG',
                              {row:failureDetail.lineNo,
                              column:failureDetail.itemIndex
                              });
            }
            // document.getElementById('textarea_result').value = this.resultstr
          });
        }
      },
      searchDistribution(){
        this.resultstr = ""
        // document.getElementById('textarea_result').value = "";
        this.$emit("update:visible", false);
        this.$emit("successAccountIdList", this.successAccountId);
        this.query.fileName = null;
        this.query.file = null;
        this.dialogVisible = false;
        this.successAccountId = []
        this.failureDetails = [
          {
            lineNo: null,
            message: '',
          }
        ]

      },
      loadInfo(){
        this.userInfo = this.$getLoginInfo()
        this.tenantId = this.userInfo.tenantId
        this.ownerId  = this.userInfo.ownerId
      },
    },
    created() {
      this.loadInfo();
    }
})
</script>

<style lang="scss" scoped>

  ::v-deep .el-dialog--center .el-dialog__body {
      text-align: initial;
      height: 520px;
  }

  .flex-align-items-center {
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }

  .hr-style{
    width: 944px;
    height: 0px;
    gap: 0px;
    border: 1px 0px 0px 0px;
  }

  ::v-deep .cancel-width{
    .my-button{
      width: 152px;
      height: 32px;
    }
    .create {
      line-height: normal;
    }
  }

  ::v-deep .el-dialog{
    padding: 0px !important;
  }

  ::v-deep .title[data-v-3fcdd81b] {
    margin-left: 26px;
    font-family: Hiragino Kaku Gothic Pro;
    font-size: 24px;
    font-weight: 300;
    line-height: 36px;
    text-align: left;
  }


  ::v-deep .title label{
    width: 620px;
  }

  .title {
    width: 200px;
    text-align: left;
    margin-bottom: 10px;
  }

  .selectBtns {
    ::v-deep.my-button {
      background-color: #F7F7F2 !important;
      width: 63px;
      margin-left: 20px;
      float:left;
      width: 63px;
      height: 40px;
    }
  }
  .csvBtn{
    ::v-deep .my-button {
      margin-left: 20px;
      float:left;
      width: 84px;
      height: 40px;
      background-color: rgb(50, 156, 166) !important;
    }
  }

.container-body{
  margin: 40px 0px 0px 40px;
}

.input-margin-top{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
}

.main-1{
  margin-left: 100px;
}

.box-1{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  text-align: left;
}

.margin-top{
  margin-top: 20px;
}

.item-height {
  ::v-deep .el-form-item__label {
    line-height: 44px;
  }
}

.input-width {
  float:left;
  width: 200px;
}

.input-width{
  width: 324px;
  height: 44px;
}

.label-with {
  width: 130px;
}

.float-left {
  float:left;
}

.color {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
}

::v-deep .in-file-url-two {
  width: 513px;
  height: 160px;
  .el-textarea__inner {
    border-radius: 8px !important;
    width: 513px !important;
    height: 160px !important;
    background: #F2F2ED !important;
    padding: 10px !important;

  }
}

::v-deep .element.style{
  min-height: 0px;
}

.textarea-1{
  ::v-deep.el-textarea__inner{
    min-height: 0px !important;
  }
}

.m-top{
  margin-top: 40px
}

.body-end{
  margin-top: 25%;
  padding-left: 40px;
}

::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before {
  display: none;
}

.m-bottom-head{
  margin-bottom: 40px !important;
}

.label-title{

  font-family: Hiragino Kaku Gothic Pro;
  font-size: 24px;
  font-weight: 300;
  line-height: 36px;
  text-align: left;
}

.box-head{
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.btn-cancel{
  text-align: right;
  margin-right: 16px;
  flex: 1;
}

.btn-parimary{
  min-width: max-content;
  padding-right: 20px;
}

.hr-style{
  margin-bottom: 40px;
  width: 944px;
  height: 0px;
  gap: 0px;
  border: 1px;
  border: 1px solid #BFBFBF
}

.msg_box_style{
  border-radius: 8px;
  width: 513px;
  height: 160px;
  padding: 10px;
  font-size: 16px;
  background: #f2f2ed;
  box-shadow: inset -2px -2px 4px #fff, inset -2px -2px 4px #fff, inset 2px 2px 4px #e6e6d8, inset 2px 2px 4px #e6e6d8 !important;
  word-break: pre-line;
  white-space:pre-wrap;
  overflow: auto;
}
</style>
